import React from 'react';

import { AccountInformation, StepProgress, Success } from './components';
import ProvisionBotNumber from './components/ProvisionBotNumber';
import { STEP } from './constants';
import { CreateAccountContext } from './context';
import { useCreateAccountReducer } from './reducer';

const CreateAccount: React.FC = () => {
  const [state, dispatch] = useCreateAccountReducer();
  const { step } = state;
  return (
    <CreateAccountContext.Provider value={{ state, dispatch }}>
      <div className="sm:px-6 lg:px-8 flex flex-col h-full px-4 py-8 overflow-auto">
        <h2>Add account</h2>
        <StepProgress />
        {step === STEP.CREATING_ACCOUNT && <AccountInformation />}
        {step === STEP.PROVISIONING_BOT_NUMBER && <ProvisionBotNumber />}
        {step === STEP.FINISHED && <Success />}
      </div>
    </CreateAccountContext.Provider>
  );
};

export default CreateAccount;
